module.exports = __webpack_public_path__ + "img/ksm.301127d8.svg";